export default __webpack_public_path__ + "static/media/seattle.8af1ac07.jpg";